import { render, staticRenderFns } from "./ProfileAccountDetails.vue?vue&type=template&id=3aa0cc78"
import script from "./ProfileAccountDetails.vue?vue&type=script&lang=js"
export * from "./ProfileAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports